import React from 'react'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

const speedy = typeof navigator === 'undefined' ||
    navigator.userAgent.toLowerCase().indexOf('prerender') === -1

const emotionCache = createCache({
    key: 'emotion-cache',
    speedy: speedy
})

const EmotionWrapper = ({ children }) => (
    <CacheProvider value={emotionCache}>
        {children}
    </CacheProvider>
)

export default EmotionWrapper
